import { Component, signal, computed, ChangeDetectionStrategy, forwardRef, Injector, OnInit } from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR, NgControl } from '@angular/forms';
import { CorpControlCommonComponent } from '../../common/corp-control-common/corp-control-common.component';

@Component({
    selector: 'corp-input-radio',
    standalone: true,
    templateUrl: 'corp-input-radio.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ FormsModule],
    
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CorpInputRadioComponent),
            multi: true,
        },
    ],
})
export class CorpInputRadioComponent extends CorpControlCommonComponent implements OnInit {

    constructor(
        private injector: Injector
    ) {
        super()
    }

    ngOnInit(): void {
        const ngControl = this.injector.get(NgControl, null);
        this.setNgControl(ngControl);
    }

    activeLaser = false;

triggerClick() {
  this.activeLaser = true;

  setTimeout(() => {
    this.activeLaser = false;
  }, 600);
}

}